import React, { useEffect, useState } from "react";
import { FormikProvider, useFormik, Field, Form, ErrorMessage } from "formik";
import * as jnb from "react-bootstrap";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { ERROR_MSG } from "../CommonUtils/contextVariables";

const ChangeOfInstNameAppDtls = () => {
  const username = sessionStorage.getItem("user_name");
  const [instDta, setInstDta] = useState(false);
  const initialValues = {
    currentName: "",
    proposedNewName: "",
    reasonForNameChange: "",
    teluguNewspaper1: "",
    pubDate1: "",
    teluguNewspaper2: "",
    pubDate2: "",
    englishNewspaper: "",
    pubDate3: "",
  };

  const validationSchema = Yup.object().shape({
    currentName: Yup.string().required(ERROR_MSG),
    proposedNewName: Yup.string().required(ERROR_MSG),
    reasonForNameChange: Yup.string().required(ERROR_MSG),
    teluguNewspaper1: Yup.string().required(ERROR_MSG),
    pubDate1: Yup.date().required("Date is required"),
    teluguNewspaper2: Yup.string().required(ERROR_MSG),
    pubDate2: Yup.date().required(ERROR_MSG),
    englishNewspaper: Yup.string().required(ERROR_MSG),
    pubDate3: Yup.date().required(ERROR_MSG),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to submit the name change details?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, submit it!",
        cancelButtonText: "No, cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            currentName: values.currentName,
            proposedNewname: values.proposedNewName,
            reasonChange: values.reasonForNameChange,
            teluguNewsPaper1: values.teluguNewspaper1,
            teluguPaper1Publisheddate: values.pubDate1,
            teluguNewsPaper2: values.teluguNewspaper2,
            teluguPaper2Publisheddate: values.pubDate2,
            englishNewsPaper: values.englishNewspaper,
            englishPaperPublisheddate: values.pubDate3,
          };
          const url = `${config.url.FAC_URL}saveInstNameDetails`;
          CommonAxiosPost(url, payload)
            .then((res) => {
              if (res?.data?.scode === "01") {
                Swal.fire({
                  title: res.data.sdesc || "Name Change Submitted!",
                  icon: "success",
                  backdrop: false,
                  confirmButtonText: "OK",
                }).then((successResult) => {
                  if (successResult.isConfirmed) {
                    GetInstNameDetails();
                  }
                });
              } else {
                Swal.fire({
                  text: res.data?.ResponseDesc || "Submission failed",
                  icon: "warning",
                });
              }
            })
            .catch((err) => {
              console.error("API Error:", err);
              Swal.fire({
                text: "Something went wrong while submitting the request!",
                icon: "error",
              });
            })
            .finally(() => {
              setSubmitting(false);
            });
        } else {
          setSubmitting(false);
        }
      });
    },
  });
  const { handleSubmit } = formik;

  function GetInstNameDetails() {
    let Url = `${config.url.FAC_URL}getInstNameDetails`;
    CommonAxiosGet(Url)
      .then((res) => {
        if (res.data.status === true && res.data.data?.length > 0) {
          setInstDta(true);
          const locData = res.data.data[0];
          formik.setFieldValue("currentName", locData.current_name || "");
          formik.setFieldValue(
            "proposedNewName",
            locData.proposed_newname || "",
          );
          formik.setFieldValue(
            "reasonForNameChange",
            locData.reason_change || "",
          );

          // Telugu Newspaper 1
          formik.setFieldValue(
            "teluguNewspaper1",
            locData.telugu_news_paper1 || "",
          );
          formik.setFieldValue(
            "pubDate1",
            locData.telugu_paper1_publisheddate || "",
          );

          // Telugu Newspaper 2
          formik.setFieldValue(
            "teluguNewspaper2",
            locData.telugu_news_paper2 || "",
          );
          formik.setFieldValue(
            "pubDate2",
            locData.telugu_paper2_publisheddate || "",
          );

          // English Newspaper
          formik.setFieldValue(
            "englishNewspaper",
            locData.english_news_paper || "",
          );
          formik.setFieldValue(
            "pubDate3",
            locData.english_paper_publisheddate || "",
          );
        } else {
          console.log("No institution name details found or error in response");
        }
      })
      .catch((err) => {
        console.error("API Fetch Error:", err);
      });
  }
  useEffect(() => {
    formik.setFieldValue("currentName", username);
    GetInstNameDetails();
  }, []);

  return (
    <jnb.Container fluid className="py-3">
      <jnb.Card className="shadow-sm border-0 rounded-0 rounded-bottom mb-4">
        <jnb.Card.Body className="p-4">
          <FormikProvider value={formik}>
            <Form onSubmit={handleSubmit}>
              <jnb.Row className="g-4">
                <h5 className="mb-3 innerheader-new">
                  <span> Change of Institution Name</span>
                </h5>
                {/* Current Name */}
                <jnb.Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    Current Name <span className="text-danger">*</span>
                  </jnb.Form.Label>
                  <Field name="currentName" className="form-control" readOnly />
                  <ErrorMessage
                    name="currentName"
                    component="div"
                    className="text-danger extra-small mt-1"
                  />
                </jnb.Col>

                {/* Proposed New Name */}
                <jnb.Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    Proposed New Name <span className="text-danger">*</span>
                  </jnb.Form.Label>
                  <Field
                    name="proposedNewName"
                    className="form-control"
                    placeholder="New proposed name"
                    disabled={instDta}
                  />
                  <ErrorMessage
                    name="proposedNewName"
                    component="div"
                    className="text-danger extra-small mt-1"
                  />
                </jnb.Col>

                <jnb.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                  <jnb.Form.Group className="mb-3">
                    <jnb.Form.Label className="small fw-bold text-dark">
                      Reason for Name Change{" "}
                      <span className="text-danger">*</span>
                    </jnb.Form.Label>
                    <Field
                      as="textarea"
                      name="reasonForNameChange"
                      disabled={instDta}
                      rows={4}
                      placeholder="Explain the reason for this Name change..."
                      className="form-control"
                      style={{
                        width: "100%",
                        resize: "vertical",
                        minHeight: "100px",
                      }}
                    />
                    <ErrorMessage
                      name="reasonForNameChange"
                      component="div"
                      className="text-danger extra-small mt-1"
                    />
                  </jnb.Form.Group>
                </jnb.Col>

                {/* Newspaper Publication Details Section */}
                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                  <h5 className="mb-3 innerheader-new">
                    <span> Newspaper Publication Details</span>
                  </h5>
                </jnb.Col>

                {/* Telugu Newspaper 1 */}
                <jnb.Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    Telugu Newspaper 1 <span className="text-danger">*</span>
                  </jnb.Form.Label>
                  <Field name="teluguNewspaper1" className="form-control" disabled={instDta} />
                  <ErrorMessage
                    name="teluguNewspaper1"
                    component="div"
                    className="text-danger extra-small mt-1"
                  />
                </jnb.Col>
                <jnb.Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    Publication Date <span className="text-danger">*</span>
                  </jnb.Form.Label>
                  <Field type="date" name="pubDate1" className="form-control" disabled={instDta} />
                  <ErrorMessage
                    name="pubDate1"
                    component="div"
                    className="text-danger extra-small mt-1"
                  />
                </jnb.Col>

                {/* Telugu Newspaper 2 */}
                <jnb.Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    Telugu Newspaper 2 <span className="text-danger">*</span>
                  </jnb.Form.Label>
                  <Field name="teluguNewspaper2" className="form-control" disabled={instDta} />
                  <ErrorMessage
                    name="teluguNewspaper2"
                    component="div"
                    className="text-danger extra-small mt-1"
                  />
                </jnb.Col>
                <jnb.Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    Publication Date <span className="text-danger">*</span>
                  </jnb.Form.Label>
                  <Field type="date" name="pubDate2" className="form-control" disabled={instDta}/>
                  <ErrorMessage
                    name="pubDate2"
                    component="div"
                    className="text-danger extra-small mt-1"
                  />
                </jnb.Col>

                {/* English Newspaper */}
                <jnb.Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    English Newspaper <span className="text-danger">*</span>
                  </jnb.Form.Label>
                  <Field name="englishNewspaper" className="form-control" disabled={instDta}/>
                  <ErrorMessage
                    name="englishNewspaper"
                    component="div"
                    className="text-danger extra-small mt-1"
                  />
                </jnb.Col>
                <jnb.Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    Publication Date <span className="text-danger">*</span>
                  </jnb.Form.Label>
                  <Field type="date" name="pubDate3" className="form-control" disabled={instDta} />
                  <ErrorMessage
                    name="pubDate3"
                    component="div"
                    className="text-danger extra-small mt-1"
                  />
                </jnb.Col>

                {/* Submit Action */}
                {!instDta ? (
                  <jnb.Col md={12} className="d-flex justify-content-end mt-4">
                    <button className="btn btn-primary" type="submit">
                      Submit
                    </button>
                  </jnb.Col>
                ) : (
                  <div className="d-flex justify-content-end mt-3">
                    <span className="text-success fw-bold">
                      Already Submitted
                    </span>
                  </div>
                )}
              </jnb.Row>
            </Form>
          </FormikProvider>
        </jnb.Card.Body>
      </jnb.Card>

      <style>{`
        .extra-small { font-size: 0.75rem; }
        .form-control:focus { border-color: #74b9ff; box-shadow: 0 0 0 0.2rem rgba(116, 185, 255, 0.25); }
        input[type="date"]::-webkit-calendar-picker-indicator { cursor: pointer; }
      `}</style>
    </jnb.Container>
  );
};

export default ChangeOfInstNameAppDtls;
